import React from 'react';
import { VideoPlayer } from './VideoPlayer';
import { galleryImageUrl, isVideo } from './cloudinary';

// A page's photos and videos in one column. Everything renders at once and the
// browser lazy-loads each image as it nears the screen. width/height (from the
// data) reserve each image's space before it loads, so the page doesn't jump
// and the browser doesn't treat every zero-height image as on screen.
const GalleryList = ({ items, showText = false }) => (
    <div className='flex flex-col space-y-4'>
        {items.map((item) => (
            <div key={item.image_url} className='flex flex-col items-center'>
                {showText && item.text &&
                    <div className='text-white self-start'>
                        {item.text}
                    </div>
                }

                {isVideo(item.image_url)
                    ? <VideoPlayer image_url={item.image_url} width={item.width} height={item.height} />
                    : <img
                        src={galleryImageUrl(item.image_url)}
                        width={item.width}
                        height={item.height}
                        loading='lazy'
                        decoding='async'
                        alt={item.alt}
                        className='520:max-w-[500px] max-w-full w-full h-auto'
                    />
                }
            </div>
        ))}
    </div>
);

export default GalleryList
